import { Component, OnDestroy, OnInit, inject, viewChild } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { Position } from 'geojson';
import { isEqual as _isEqual } from 'lodash';
import { takeUntil, tap } from 'rxjs/operators';

import { FormControl, FormGroup } from '@angular/forms';
import {
  SmartSmsRequestPolygonWithTitleModel,
  SmsAggregator,
} from 'src/app/core/api/models';
import { CustomResult } from 'src/app/core/api/models/custom-result';
import {
  SmartSmsRequestsService,
  ZonesService,
} from 'src/app/core/api/services';
import { EventTypes } from 'src/app/core/constants/event-types';
import { AppStateService } from 'src/app/core/services/app-state.service';
import {
  DialogService,
  DialogStatus,
} from 'src/app/core/services/dialog.service';
import { AppDomService } from 'src/app/core/services/dom.service';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { AppSelectedAggregator } from 'src/app/core/types/app-selected-aggregator.type';
import { TabsDynamicComponent } from 'src/app/layout/components/tabs-dynamic/tabs-dynamic.component';
import { ZonesSelectSearchComponent } from 'src/app/shared/components/select-search/zones-select-search.component';
import { SmartSendMapControlComponent } from 'src/app/shared/components/smart-send-map-control/smart-send-map-control.component';
import { BaseFormPageComponent } from '../../shared/base/components/base-form-page.component';
import { SendSmartSmsAdvanceSearchlComponent } from '../send-smart-sms-create-request/send-smart-sms-advance-search/send-smart-sms-advance-search.component';
import { SendSmartSmsToResidentsRequestNameDialog } from './request-name-dialog/request-name.component';

@Component({
    selector: 'app-send-smart-sms-to-residents',
    templateUrl: './send-smart-sms-to-residents.component.html',
    styleUrls: ['./send-smart-sms-to-residents.component.scss'],
    standalone: false
})
export class SendSmartSmsToResidentsComponent
  extends BaseFormPageComponent
  implements OnInit, OnDestroy
{
  appStateService = inject(AppStateService);
  tabName: string = 'sendSmartSmsToResidents';
  isVisibleHelpPage: boolean = false;
  polygon: number[][][] = null;
  selectedMode: AppSelectedAggregator = 'hamrahAval';
  operators: Array<SmsAggregator> = [];
  get SmsAggregator() {
    return SmsAggregator;
  }
  selectedOperator: SmsAggregator;
  stateId: number = null;
  cityId: number = null;

  readonly Map = viewChild<SmartSendMapControlComponent>('Map');
  readonly citySelectSearch = viewChild<ZonesSelectSearchComponent>('citySelectSearch');

  constructor(
    protected currentService: SmartSmsRequestsService,
    public dynamicTabService: DynamicTabService,
    private tabsDynamicComponent: TabsDynamicComponent,
    public dialogService: DialogService,
    public zoneService: ZonesService,
    private translate: TranslateService
  ) {
    super();
  }

  initForm(): void {
    this.pageVocabs = 'pages.sendSmartSmsToResidents.';

    this.form = new FormGroup({
      stateControl: new FormControl(''),
      cityControl: new FormControl(''),
    });
  }

  openPage(tabName: string) {
    try {
      this.dynamicTabService.setNewTab('');
      this.dynamicTabService.setNewTab(tabName);
      this.dynamicTabService.setActiveTab(tabName);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
    }
  }
  onShowHelpPage() {
    this.isVisibleHelpPage = true;
  }
  onHideHelpPage() {
    this.isVisibleHelpPage = false;
  }
  refreshPage() {
    this.tabsDynamicComponent.refreshTab(this.tabName);
  }
  onShowAdvanceSearch() {
    const modalResult = this.dialogService.openModal({
      width: '800px',
      minHeight: '500px',
      component: SendSmartSmsAdvanceSearchlComponent,
    });
    modalResult
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .pipe(this.basePipeOperators())
      .subscribe((res) => {
        var polygons: any[] = [];
        res.forEach((polygon) => {
          if (typeof polygon == typeof '') polygons.push([JSON.parse(polygon)]);
          //this.Map.AddDisplayPolygon('', );
          else polygons.push(this.convertMapIrPolygonToGmap(polygon));
          //this.Map.AddDisplayPolygon('', this.convertMapIrPolygonToGmap(polygon))
        });
        this.Map().AddDisplayPolygons('', polygons);
      });
  }

  convertMapIrPolygonToGmap(polygon: number[][]): Position[][] {
    var result: Position[][] = [[]];
    polygon.forEach((item) => {
      result[0].push([item[1], item[0]]);
    });
    return result;
  }

  ConvertPolygonsTo3plNumberArray(
    input: Array<Position[][]>
  ): number[][][] | null {
    var pls: number[][][] = [];
    input.forEach((polygon) => {
      var item: number[][] = [];
      polygon[0].forEach((it2) => {
        item.push(it2);
      });
      pls.push(item);
    });
    return pls;
  }

  onCityChange($event) {
    if (this.citySelectSearch() == null) return;
    this.cityId = $event;
    this.zoneService
      .zonesGetZoneCoordinates({ ZoneId: this.cityId })
      .subscribe((result) => {
        try {
          let center = JSON.parse(result?.data) as mapboxgl.LngLatLike;
          var tmp = center[0];
          center[0] = center[1];
          center[1] = tmp;
          this.Map().SetCenter(center);
        } catch (error) {
          this.loggerService.logError(this.tagName, error, EventTypes.smartSms);
        }
      });
  }

  onSaveClick() {
    let selectedPolygons;
    let polygonsTitle: any[] = [];
    const Map = this.Map();
    if (Map) {
      selectedPolygons = this.ConvertPolygonsTo3plNumberArray(
        Map.getAllPolygons()
      );
      polygonsTitle = Map.getAllPolygonTitles();
    }

    if (selectedPolygons.length <= 0 && this.polygon == null) {
      this.dialogService.openDialog({
        title: this.translate.instant('common.error'),
        message: this.translate.instant(
          this.pageVocabs + 'errors.mostSelectPolygon'
        ),
        status: DialogStatus.error,
      });
      return;
    }

    if (this.operators.length <= 0) {
      this.dialogService.openDialog({
        title: this.translate.instant('common.error'),
        message: this.translate.instant(
          this.pageVocabs + 'errors.mustSelectOperator'
        ),
        status: DialogStatus.error,
      });
      return;
    }

    let drawedPolygons: Array<SmartSmsRequestPolygonWithTitleModel> = [];
    selectedPolygons.forEach((element) => {
      let polygonObject = polygonsTitle.find((item) =>
        _isEqual(item.coordinates, element)
      );

      let polygon: SmartSmsRequestPolygonWithTitleModel = {
        polygons: element,
        title: polygonObject?.title,
      };
      drawedPolygons.push(polygon);
    });

    this.dialogService
      .openModal({
        component: SendSmartSmsToResidentsRequestNameDialog,
      })
      .afterClosed()
      .pipe(
        takeUntil(this.onDestroy$),
        tap(() => {
          AppDomService.removeModalScrollClassFromHtml();
        })
      )
      .subscribe((result) => {
        if (result) {
          //now we call the api
          this.loading = true;
          this.currentService
            .smartSmsRequestsCreateResidentSmartSmsRequest({
              body: {
                //    recipients: recipients,
                title: result,
                operators: this.operators,
                polygons: drawedPolygons,
                // polygons:
                //   selectedPolygons.length > 0
                //     ? selectedPolygons
                //     : JSON.parse(this.polygon.toString()),
              },
            })
            .pipe(this.basePipeOperators())
            .subscribe((res: CustomResult) => {
              if (!res.isSucceed) {
                this.loading = false;
                //TODO change message dialog
                this.dialogService.openDialog({
                  title: res?.message ?? this.translate.instant('common.error'),
                  message: res?.validationErrors?.join('\n'),
                  status: DialogStatus.error,
                });
              } else {
                this.loading = false;
                this.dialogService.openDialog({
                  title: res?.message ?? this.translate.instant('common.error'),
                  message: res?.validationErrors?.join('\n'),
                  status: DialogStatus.success,
                });
                this.formPageConfig.isEditMode = false;
                this.refreshPage();
              }
            });
        }
      });
  }
}
